import React, { useState } from "react";
import { Drawer, Modal } from "antd";

export default function Overlay(props) {

    const { maskClosable = true, component, width = 1024, inline = false, auto_open = false, callback = () => { }, disabled = false } = props;
    const [modalVisible, setModalVisible] = useState(auto_open);

    const close = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        callback();
        setModalVisible(false);
    }



    return (
        <div onClick={(e) => e.stopPropagation()}>
            <Modal

                onCancel={(e) => close(e)}
                maskClosable={maskClosable}
                open={modalVisible}
                closable={true}
                bodyStyle={{ "padding": "0px", "margin": "0px" }}
                destroyOnClose
                width={width}
                footer={null}

            >
                <div>
                    {React.cloneElement(component, { close: close })}
                </div>

            </Modal>
            <div style={{ "display": (inline) ? "inline" : "block" }} onClick={(e) => { if (disabled) { return }; e.preventDefault(); e.stopPropagation(); setModalVisible(true) }}> {props.children}</div>
        </div>
    );

}